import { Button } from "antd";

const ButtonExportPDF = ({ onClick }) => {
  // const onClick = () => {
  //   console.log("PDF Print");
  // };

  return (
    <div>
      <Button
        size="large"
        className=" bg-red-500 text-white py-2 px-4 rounded-md mb-4"
        onClick={onClick}
      >
        Export PDF
      </Button>
    </div>
  );
};

export default ButtonExportPDF;
